import React from 'react'
const CallAction = () => {
    return (
        <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
            <div className="container">
                <div className="row">
                <div className="inner text-center">
                            <span>¿Quieres obtener el mejor contenido gratuito sobre marketing?</span>
                            <h2>No esperes más</h2>
                            <a className="rn-button-style--2" href="/courses"><span>Suscríbete de manera gratuita</span></a>
                        </div>
                </div>
            </div>
        </div>
    )
}
export default CallAction;